import { render, staticRenderFns } from "./QuienesSomosHomeComp.vue?vue&type=template&id=4310ac9a&scoped=true&"
import script from "./QuienesSomosHomeComp.vue?vue&type=script&lang=js&"
export * from "./QuienesSomosHomeComp.vue?vue&type=script&lang=js&"
import style0 from "./QuienesSomosHomeComp.vue?vue&type=style&index=0&id=4310ac9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310ac9a",
  null
  
)

export default component.exports